import { first } from "lodash";

function isBuffer(obj: any) {
    return obj &&
        obj.constructor &&
        (typeof obj.constructor.isBuffer === 'function') &&
        obj.constructor.isBuffer(obj);
}

function keyIdentity(key: any) {
    return key;
}

export function flatten(target: any, opts?: any) {
    opts = opts || {};

    const delimiter = opts.delimiter || '.';
    const maxDepth = opts.maxDepth;
    const transformKey = opts.transformKey || keyIdentity;
    const output: any = {};

    function step(object: any, prev?: any, currentDepth?: any) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function (key) {
            const value = object[key];
            const isarray = opts.safe && Array.isArray(value);
            const type = Object.prototype.toString.call(value);
            const isbuffer = isBuffer(value);
            const isobject = (
                type === '[object Object]' ||
                type === '[object Array]'
            );

            const newKey = prev
                ? prev + delimiter + transformKey(key)
                : transformKey(key);

            if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
                (!opts.maxDepth || currentDepth < maxDepth)) {
                return step(value, newKey, currentDepth + 1);
            }

            output[newKey] = value;
        });
    }

    step(target);

    return output;
}

export function unFlatten(target: any, opts?: any) {
    opts = opts || {};

    const delimiter = opts.delimiter || '.';
    const overwrite = opts.overwrite || false;
    const transformKey = opts.transformKey || keyIdentity;
    const result = {};

    const isbuffer = isBuffer(target);
    if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
        return target;
    }

    // safely ensure that the key is
    // an integer.
    function getkey(key: any) {
        const parsedKey = Number(key);

        return (
            isNaN(parsedKey) ||
            key.indexOf('.') !== -1 ||
            opts.object
        ) ? key
            : parsedKey;
    }

    function addKeys(keyPrefix: any, recipient: any, _target: any) {
        return Object.keys(_target).reduce(function (_result, key) {
            _result[keyPrefix + delimiter + key] = _target[key];

            return _result;
        }, recipient);
    }

    function isEmpty(val: any) {
        const type = Object.prototype.toString.call(val);
        const isArray = type === '[object Array]';
        const isObject = type === '[object Object]';

        if (!val) {
            return true;
        } else if (isArray) {
            return !val.length;
        } else if (isObject) {
            return !Object.keys(val).length;
        }
        return false;
    }

    target = Object.keys(target).reduce(function (_result: any, key: any) {
        const type = Object.prototype.toString.call(target[key]);
        const isObject = (type === '[object Object]' || type === '[object Array]');
        if (!isObject || isEmpty(target[key])) {
            _result[key] = target[key];
            return _result;
        } else {
            return addKeys(
                key,
                _result,
                flatten(target[key], opts)
            );
        }
    }, {});

    Object.keys(target).forEach(function (key) {
        const split = key.split(delimiter).map(transformKey);
        let key1 = getkey(split.shift());
        let key2 = getkey(split[0]);
        let recipient: any = result;

        while (key2 !== undefined) {
            if (key1 === '__proto__') {
                return;
            }

            const type = Object.prototype.toString.call(recipient[key1]);
            const isobject = (
                type === '[object Object]' ||
                type === '[object Array]'
            );

            // do not write over falsey, non-undefined values if overwrite is false
            if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
                return;
            }

            if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
                recipient[key1] = (
                    typeof key2 === 'number' &&
                        !opts.object ? [] : {}
                );
            }

            recipient = recipient[key1];
            if (split.length > 0) {
                key1 = getkey(split.shift());
                key2 = getkey(split[0]);
            }
        }

        // unflatten again for 'messy objects'
        recipient[key1] = unFlatten(target[key], opts);
    });

    return result;
}


export function setAllSelectedFieldsToFalse(flatObj: any, field: string) {
    Object.keys(flatObj).forEach(key => {
        const lastDot = key.lastIndexOf(".");
        const lastField = key.substring(lastDot + 1, key.length);

        if (lastField === field) {
            flatObj[key] = false;
        }
        if (typeof flatObj[key] === "object" && flatObj[key] !== null) {
            setAllSelectedFieldsToFalse(flatObj[key], field);
        }
    });
}

export function setAllSelectedFieldsToTrue(flatObj: any, field: string) {
    Object.keys(flatObj).forEach(key => {
        const lastDot = key.lastIndexOf(".");
        const lastField = key.substring(lastDot + 1, key.length);

        if (lastField === field) {
            flatObj[key] = true;
        }
        if (typeof flatObj[key] === "object" && flatObj[key] !== null) {
            setAllSelectedFieldsToFalse(flatObj[key], field);
        }
    });
}

// function setAllselectedFieldsToFalseOnFlatObj(obj: any) {
//     Object.keys(obj).forEach(key => {
 
//         if (key === "selected") {
//             obj[key] = false;
//         }
//     });
// }

 
// setAllselectedFieldsToFalse(flatObj);
 

// function traverseStringSeparatedByDots(obj: any, key: string) {
 
//     const keys = key.split(".");
 
//     let tempObj = obj;
//     keys.forEach(key => {
//         tempObj = tempObj[key];
//     });
//     return tempObj;
// }

//find the value of type in the flattened object called flatObj


export function selectUserInObjectAndSetAllChildrenAsSelected(flatObj: any, userKeyToSelect: string, field: string, type: string) {

    let result;
    Object.keys(flatObj).filter(key => {
        //remove last section from the last . in key string
        const lastDot = key.lastIndexOf(".");
        const truncKey = key.substring(0, lastDot);
        const lastField = key.substring(lastDot + 1, key.length);

        const secondLastDot = truncKey.lastIndexOf(".");
        const secondTruncKey = truncKey.substring(0, secondLastDot);
 
        const secondLastField = truncKey.substring(secondLastDot + 1, truncKey.length);
 

 
 
 
        const isOfTypeUser = flatObj[`${truncKey}.type`] === type; // && lastField === "type" ;
        const isUserKey = lastField === "key" && flatObj[key] === userKeyToSelect;
 
        if (isOfTypeUser && isUserKey) {
 
            //find all the childrem of this user
            const userChildren = Object.keys(flatObj).filter(childKey => {
 
 
 
 
                const searchString = `${secondTruncKey}.`;
                return (childKey.substring(0, searchString.length)).includes(searchString);
            }
            );
 

            for (let i = 0; i < userChildren.length; i++) {
 
                const key = userChildren[i];
                const lastDot = key.lastIndexOf(".");
                const truncKey = key.substring(0, lastDot);
                const lastField = key.substring(lastDot + 1, key.length);

                const secondLastDot = truncKey.lastIndexOf(".");
                const secondTruncKey = truncKey.substring(0, secondLastDot);
 
                const secondLastField = truncKey.substring(secondLastDot + 1, truncKey.length);
 

 

                flatObj[`${secondTruncKey}.${field}`] = true;
                // if(secondLastField === "selected") {
                //     flatObj[secondTruncKey].selected = true;
                // }
            }
        };

        result = flatObj;
    });
    return result;
}

export function selectHatWithUserInObjectAndSetAllChildrenAsSelectedTrue(flatObj: any, userKeyToSelect: string, field: string, type: string) {

    const foundChildrenKeys: any = [];
    const userChildren: any = [];
    Object.keys(flatObj).forEach(key => {
        const lastDot = key.lastIndexOf(".");
        const truncKey = key.substring(0, lastDot);
        const lastField = key.substring(lastDot + 1, key.length);

        const isOfTypeUser = flatObj[`${truncKey}.uid`] === userKeyToSelect; // && lastField === "type" ;
        if (isOfTypeUser && lastField === "uid") {
            const firstNFields = (n: number, ofKey: string, fieldName: string) => {
                const keySplitAsFields = ofKey.split(".");
                return keySplitAsFields.slice(0, n).join(".") + "." + fieldName;
            };

            flatObj[`${firstNFields(2, key, "selected")}`] = true;  // "children.2.selected"
            const foundKey = `${firstNFields(2, key, "selected")}`;
            const lastDot = foundKey.lastIndexOf(".");
            const foundKeyTrunc = foundKey.substring(0, lastDot);

            foundChildrenKeys.push(foundKeyTrunc);
        }
    });

 

    Object.keys(flatObj).forEach(key => {
        const exists = foundChildrenKeys.some((item: any) => {
            const firstPart = key.substring(0, item.length);
            if (firstPart === item) {
                return key.includes(item);
            } else {
                return false;
            }
        });


        if (exists && key.includes("selected") && isSecondLastFieldNumber(key)) {
            userChildren.push(key);
            // NOTE: Could do the updating of selected field to true right here perhaps. Just need to cater for the foundChildrenKeys too
        }
    });

    const foundChildrenKeys2: any = [];

    foundChildrenKeys.forEach((key: any) => {
        //add .selected to the end of the key
        foundChildrenKeys2.push(`${key}.selected`);
    }
    );

    userChildren.push(...foundChildrenKeys2);
 


    for (let i = 0; i < userChildren.length; i++) {
        const key = userChildren[i];
        flatObj[`${key}`] = true;
    }
 

    return flatObj;
}

function isSecondLastFieldNumber(str: string) {
    // Split the string by dots
    const parts = str.split('.');

    // Check if there are at least two fields before the last dot
    if (parts.length < 3) {
        return false;
    }

    // Get the second last field
    const secondLastField: any = parts[parts.length - 2];

    // Check if the second last field is a number
    return !isNaN(secondLastField);
}


// const obj = {
//     "selected": false,
//     "color": "white",
//     "background": "#c2185b",
//     "data": {
//         "depth": 1,
//         "key": "client-abc",
//         "name": "Client ABC",
//         "type": "feature"
//     },
//     "children": [
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "7LJ1iQ2J1LbLpoTCCdb3d77JKaE2",
//                 "name": "Keagan Fouche",
//                 "userName": "Keagan Fouche",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "qqyO5Lq4fFAN0NQe3z5Z",
//                         "name": "Newgenus Bloak",
//                         "hatName": "Newgenus Bloak",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "view-own-client-abc",
//                                         "name": "view-own-client-abc",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "view-company-client-abc",
//                                         "name": "view-company-client-abc",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Newgenus Bloak *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "checklist",
//                                         "name": "checklist",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-integrations",
//                                         "name": "organization-integrations",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-settings",
//                                         "name": "organization-settings",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-targets",
//                                         "name": "organization-targets",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "workspace",
//                                         "name": "workspace",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-dates",
//                                         "name": "organization-dates",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "client-abc",
//                                         "name": "client-abc",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "AnEhzz9jn7QWr2yeaSRR7Anz31R2",
//                 "name": "Paul van Jaarsveld",
//                 "userName": "Paul van Jaarsveld",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "cJGT3wia2EaRZdDeOW5N",
//                         "name": "Newgenus Team Leader",
//                         "hatName": "Newgenus Team Leader",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "view-own-client-abc",
//                                         "name": "view-own-client-abc",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "view-company-client-abc",
//                                         "name": "view-company-client-abc",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Newgenus Team Leader *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "checklist",
//                                         "name": "checklist",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-integrations",
//                                         "name": "organization-integrations",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-settings",
//                                         "name": "organization-settings",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-targets",
//                                         "name": "organization-targets",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "workspace",
//                                         "name": "workspace",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-dates",
//                                         "name": "organization-dates",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "client-abc",
//                                         "name": "client-abc",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "Ftx5E4EmusWFAjO6h2OGFCM13xF2",
//                 "name": "Roceal Jacobs",
//                 "userName": "Roceal Jacobs",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "mkYnydkQMrXQk8yytOku",
//                         "name": "Senior Sales Consultant 1",
//                         "hatName": "Senior Sales Consultant 1",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Senior Sales Consultant 1 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "JDO9tiUBYZfglM9EVRZ4SG5ZSw42",
//                 "name": "Virgilio Gilliland",
//                 "userName": "Virgilio Gilliland",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "mlz6OofR9vhAaJ5Mh2Sf",
//                         "name": "Internal Sales Unit  I/C",
//                         "hatName": "Internal Sales Unit  I/C",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Internal Sales Unit  I/C *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "KXejMNJlyCUInWwRdn9RtMMfaMB3",
//                 "name": "Regina Taylor",
//                 "userName": "Regina Taylor",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "2lQF9v2AH5m5WQyFYfc9",
//                         "name": "Senior Sales Consultant 3",
//                         "hatName": "Senior Sales Consultant 3",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Senior Sales Consultant 3 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "SJIhAqdcHmXoCp731VFZBVauL183",
//                 "name": "Deneal Thomas",
//                 "userName": "Deneal Thomas",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "F7MS4ldojyr7Z9PmW4Py",
//                         "name": "Internal Sales Staff 2",
//                         "hatName": "Internal Sales Staff 2",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "view-own-client-abc",
//                                         "name": "view-own-client-abc",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Internal Sales Staff 2 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "VontyzdPtxaxBbqXCx0vzQYFikJ2",
//                 "name": "Chris Meyer",
//                 "userName": "Chris Meyer",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "EqoS9rZD84BrXhZZGFVD",
//                         "name": "Communications Executive Secretary",
//                         "hatName": "Communications Executive Secretary",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Communications Executive Secretary *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "checklist",
//                                         "name": "checklist",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-targets",
//                                         "name": "organization-targets",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-settings",
//                                         "name": "organization-settings",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-integrations",
//                                         "name": "organization-integrations",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "X2e1N0n9hHhBGY5dtATFGoc31162",
//                 "name": "Lucille Coetzee",
//                 "userName": "Lucille Coetzee",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "BwRHy8wGTIzROZBA1cuU",
//                         "name": "Seinor Sales Consultant 2",
//                         "hatName": "Seinor Sales Consultant 2",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Seinor Sales Consultant 2 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "YaxPOi0W8jhiox3tMQt04RNS29N2",
//                 "name": "Lee-Ann Meyer",
//                 "userName": "Lee-Ann Meyer",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "UaeJDlKX2e9IXJmOKsJJ",
//                         "name": "Seinor Sales Consultant",
//                         "hatName": "Seinor Sales Consultant",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Seinor Sales Consultant *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "Z4Z3cfpJk2OgIRXlJ1Ft3wRFCiy1",
//                 "name": "Preeson Govender",
//                 "userName": "Preeson Govender",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "UbYzBertWljZVVXSvS4t",
//                         "name": "Sales Director",
//                         "hatName": "Sales Director",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Sales Director *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-targets",
//                                         "name": "organization-targets",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-integrations",
//                                         "name": "organization-integrations",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-settings",
//                                         "name": "organization-settings",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-dates",
//                                         "name": "organization-dates",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "cGHMqAlaNGgEe5sGmhjMxEbiqKc2",
//                 "name": "Chandrè Abrahams",
//                 "userName": "Chandrè Abrahams",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "NefRbUYKmRfjLJFGR7mo",
//                         "name": "Internal Sales Staff 1",
//                         "hatName": "Internal Sales Staff 1",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Internal Sales Staff 1 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "cehenOJqf4PZseQCALXSd1um9ir2",
//                 "name": "Yaron Schapiro",
//                 "userName": "Yaron Schapiro",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "6lu1RHOuBzeS9pJq9qT9",
//                         "name": "CEO",
//                         "hatName": "CEO",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * CEO *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "checklist",
//                                         "name": "checklist",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-integrations",
//                                         "name": "organization-integrations",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-settings",
//                                         "name": "organization-settings",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-targets",
//                                         "name": "organization-targets",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-dates",
//                                         "name": "organization-dates",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "e1ETWXjK73hh3PXr7XMPmTNhNpE3",
//                 "name": "Nicole Engelbrecht",
//                 "userName": "Nicole Engelbrecht",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "O2TiC2n4kah2ovNp7bFG",
//                         "name": "Internal Sales Staff 4",
//                         "hatName": "Internal Sales Staff 4",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Internal Sales Staff 4 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "geJ7Ry7vaEQsxMOMZQfZT7orDLm2",
//                 "name": "Danny Mirlas",
//                 "userName": "Danny Mirlas",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "4KO9DI1KfhYKcryugH20",
//                         "name": "Chief Sales officer",
//                         "hatName": "Chief Sales officer",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Chief Sales officer *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "i9mYoN7BozMTb3K8ggKwNOn829D3",
//                 "name": "Adelia Johannes",
//                 "userName": "Adelia Johannes",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "KEq4QS2jYHgu4Jxd8V6K",
//                         "name": "Administrative Assistant to Internal Sales Manager ",
//                         "hatName": "Administrative Assistant to Internal Sales Manager ",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Administrative Assistant to Internal Sales Manager  *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "iohQxHl6fMZnye0UdkpZeFlTtZn2",
//                 "name": "Meagan Booysen",
//                 "userName": "Meagan Booysen",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "ai1hFD1gstlYqh4whxAZ",
//                         "name": "Internal Sales Staff",
//                         "hatName": "Internal Sales Staff",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Internal Sales Staff *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "jh6TOR0MDKQkkGnLSq4RH5FMxok2",
//                 "name": "Farai Mukono",
//                 "userName": "Farai Mukono",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "CY3NH0E4OXwrLRD0R07i",
//                         "name": "Africa Sales Manager",
//                         "hatName": "Africa Sales Manager",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Africa Sales Manager *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "kq224fY1r9aLOOSb28w6N9QJuoo1",
//                 "name": "Nithaar Parker",
//                 "userName": "Nithaar Parker",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "PyUtZ4OLAhRX48yOO7QR",
//                         "name": "Sales Manager",
//                         "hatName": "Sales Manager",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Sales Manager *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-targets",
//                                         "name": "organization-targets",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "organization-integrations",
//                                         "name": "organization-integrations",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "lK213eLkTITsB8O9IJlClP7Hw6r2",
//                 "name": "Lester Muller",
//                 "userName": "Lester Muller",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "p0Aq9bKWJYqCdMH2uVmQ",
//                         "name": "Internal Sales Staff 3",
//                         "hatName": "Internal Sales Staff 3",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Internal Sales Staff 3 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "nTfa16Gt5RYHXl0i24e0O7yxqvv2",
//                 "name": "Carl de Kock",
//                 "userName": "Carl de Kock",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "a6z6VDo0kJk8ggqyMQEm",
//                         "name": "Treasury Secretary",
//                         "hatName": "Treasury Secretary",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "view-company-client-abc",
//                                         "name": "view-company-client-abc",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "view-own-client-abc",
//                                         "name": "view-own-client-abc",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Treasury Secretary *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 },
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "client-abc",
//                                         "name": "client-abc",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         },
//         {
//             "selected": false,
//             "color": "white",
//             "background": "#010193",
//             "data": {
//                 "depth": 2,
//                 "key": "snOfAXyGa7RRomhEmgwQI7nRmLJ3",
//                 "name": "Washiefa Appollis",
//                 "userName": "Washiefa Appollis",
//                 "type": "user"
//             },
//             "children": [
//                 {
//                     "selected": false,
//                     "color": "white",
//                     "background": "blue",
//                     "data": {
//                         "depth": 3,
//                         "key": "qZtQ5kJkFPCVgT5lvRnz",
//                         "name": "Internal Sales Staff  5",
//                         "hatName": "Internal Sales Staff  5",
//                         "type": "hat"
//                     },
//                     "children": [
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "111",
//                                 "name": "active permissions on feature * client-abc *",
//                                 "type": "permissions"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "** NO PERMISSIONS **",
//                                         "name": "** NO PERMISSIONS **",
//                                         "type": "permission"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         },
//                         {
//                             "selected": false,
//                             "color": "white",
//                             "background": "blue",
//                             "data": {
//                                 "depth": 4,
//                                 "key": "222",
//                                 "name": "all features on hat * Internal Sales Staff  5 *",
//                                 "type": "allFeaturesOnHat"
//                             },
//                             "children": [
//                                 {
//                                     "selected": false,
//                                     "color": "white",
//                                     "background": "blue",
//                                     "data": {
//                                         "depth": 2,
//                                         "key": "statistics",
//                                         "name": "statistics",
//                                         "type": "features"
//                                     },
//                                     "children": []
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             ]
//         }
//     ]
// }

// const flatObj = flatten(obj);
 
 


// setAllSelectedFieldsToFalse(flatObj, 'selected');
 

// // const userKeyToSelect = "AnEhzz9jn7QWr2yeaSRR7Anz31R2";
// // const newObj = selectUserInObjectAndSetAllChildrenAsSelected(flatObj, userKeyToSelect, 'selected', 'user')
 
 

 

// // const flatObj2 = flatten(obj);
 
